import { render, staticRenderFns } from "./ExternalPrenotazioniListPage.vue?vue&type=template&id=4354cd14"
import script from "./ExternalPrenotazioniListPage.vue?vue&type=script&lang=js"
export * from "./ExternalPrenotazioniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports